export default "__VITE_ASSET__xWP3rZgw__"